import { observer } from 'mobx-react-lite'

import { ToastProgressMessageHandler } from './types'

export const Progress = observer(
    ({ state, onMessage }: { state: { progress: number }; onMessage: ToastProgressMessageHandler }) => {
        return <div>{onMessage(state.progress)}</div>
    }
)
